module.exports = __webpack_public_path__ + "groupon/img/share-example.865e22bb.png";